import React, { Component } from "react";
import { RiPixelfedFill } from 'react-icons/ri';

export default class Footer extends Component {

  render() {
    return (
      <div className="footer d-flex justify-content-center mt-auto mt-3 pb-3">
        <div>
          <div className="justify-content-center text-center mt-4">
            <h6><img src={require('../resources/images/fmf-logo-16.png')} alt="Fmf Logo" className="fmf-ico"/> 2023 - FindMyFriends.online</h6>
          </div>
          <div className="mt-4"/>
          <a className="text-nowrap" href="https://mastodon.social/@findmyfriends" target='_blank' rel="noreferrer"><i className="bi bi-mastodon"></i> findmyfriends@mastodon.social</a>
          <br/>
          <a className="text-nowrap" href="https://pixelfed.social/@findmyfriends" target='_blank' rel="noreferrer"><RiPixelfedFill className="react-icon-footer-fix react-icon-fix"/> findmyfriends@pixelfed.social</a>
          <div className="mt-4"/>
          <div className="justify-content-center text-center">
          <a className="text-nowrap" href='https://ko-fi.com/X8X2JE03C' target='_blank' rel="noreferrer"><i className="bi bi-cup-hot-fill"></i> Buy me a coffee</a>
          </div>
        </div>
      </div>
    );
  }
}
